import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IDiligenceReport } from "../interface/IDiligenceReport";

enum DiligenceReportServiceEnum {
  diligenceQuestions = "/questions/",
  dealDiligenceQuestions = "/deal-questions/",
  hasPriceChangesFromQuestionnaire = "/has-price-changes-from-questionnaire/",
  save = "/save"
}

export default class DiligenceReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/diligence-report");
  }
  public getByTradeId = async (tradeId: number): Promise<IDiligenceReport> => await this.GET(DiligenceReportServiceEnum.diligenceQuestions + tradeId);
  public getByDealId = async (dealId: number): Promise<IDiligenceReport> => await this.GET(DiligenceReportServiceEnum.dealDiligenceQuestions + dealId);
  public save = async (data: IDiligenceReport) => await this.POST(DiligenceReportServiceEnum.save, data);
  public hasPriceChangesFromQuestionnaire = async (tradeId: number) => await this.GET(DiligenceReportServiceEnum.hasPriceChangesFromQuestionnaire + tradeId);
}
